import React from 'react';
import '../styles/Footer.css';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import { FaTiktok } from 'react-icons/fa6'; // TikTok från FontAwesome 6

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">

        <div className="footer-section about">
          <h2>Om oss</h2>
          <p>
            Vi är ett svenskt företag som specialiserat oss på att arrangera Umrah-resor
            från Sverige till Saudiarabien. <br></br>Vår mission är att erbjuda en trygg välorganiserad och andlig resa, 
            vi har både kvinnliga och manliga reseledare och alla är varmt välkomna att resa med oss.
          </p>
        </div>

        <div className="footer-section contact">
          <h2>Kontakta Oss</h2>
          <p><strong>Email:</strong> info@umrahbroderna.se</p>
          <p><strong>Telefon:</strong> 010 4700 081</p>
          <p><strong>Öppettider:</strong> 12:00 - 18.00 (alla dagar)</p>
        </div>

        <div className="footer-section social">
          <h2>Följ Oss</h2>
          <div className="social-icons">
            <a href="https://www.facebook.com/profile.php?id=61584050076590" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
            <a href="https://www.instagram.com/umrah_broderna/" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.tiktok.com/@umrahbroderna" target="_blank" rel="noopener noreferrer">
              <FaTiktok />
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 Ya Ra AB All rights reserved <br /> Organisationsnummer: 559519-7228 </p>
      </div>
    </footer>
  );
};

export default Footer;
